module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "employee"
  }, [_vm._v("\n      工号: " + _vm._s(_vm.employeeNo) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "company"
  }, [_vm._v("\n    " + _vm._s(_vm.companyName) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b8079eb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/personal-info-card.vue
// module id = 851
// module chunks = 34